import { faker } from '@faker-js/faker';
import type { SigningPageVideo } from '../types/signing-page-video';

export class VideoMock {
  static youtubeUrl = 'https://www.youtube.com/watch?v=VQqApiCj6O0';
  static vimeoUrl = 'https://vimeo.com/147573419';

  static one(video?: Partial<SigningPageVideo>): SigningPageVideo {
    return {
      id: faker.datatype.uuid(),
      thumbUrl: faker.image.avatar(),
      videoUrl: faker.internet.url(),
      ...video,
    };
  }
}
